import { getIn, useFormikContext } from 'formik';
import React from 'react';
import { MultiDateInput } from './MultiDateInput';
import { IDateInputProps } from '../DateInput';

export interface IMultiDateFieldProps extends Partial<IDateInputProps> {
  /** Text that will appear in an empty input. */
  placeholder?: string;
  onDateChange?: (startDate: string | null, endDate: string | null) => void;
  /** Name of the submitted form parameter. */
  startName: string;
  endName: string;
  startDate: string | null;
  endDate: string | null;
  hideSelectMenu?: boolean;
}

export const MultiDateField: React.FC<IMultiDateFieldProps> = ({
  startName,
  endName,
  startDate,
  endDate,
  label,
  onDateChange,
  hideSelectMenu,
  ...rest
}) => {
  const formik = useFormikContext();
  const onChange = (startValue: string | null, endValue: string | null) => {
    formik.setFieldTouched(startName as never);
    formik.setFieldValue(startName as never, startValue);
    formik.setFieldTouched(endName as never);
    formik.setFieldValue(endName as never, endValue);
    if (onDateChange) {
      onDateChange(startValue, endValue);
    }
  };
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, startName)) && !!getIn(formik.errors, startName)
      ? getIn(formik.errors, startName)
      : null;
  return (
    <MultiDateInput
      {...rest}
      onChange={onChange}
      label={label}
      errorText={errorText}
      startValue={startDate}
      endValue={endDate}
      dataTestIdStart={startName}
      dataTestIdEnd={endName}
      hideSelectMenu={hideSelectMenu}
    />
  );
};
